import { v4 as UUID } from 'uuid';
import { FabricObject, FabricObjectType } from '@/components/Editor/types/fabric';

export const setActiveSelectionId = (object: FabricObject): void => {
  if (object.type === FabricObjectType.activeSelection) {
    object.id = UUID();
  }
};
